import { isValid, parseISO } from "date-fns";
import { now } from "./now";

/**
 * Parses a date value (Date, string, null, or undefined) into a Date object.
 * If the input is invalid or null/undefined, returns the current time.
 *
 * @param dateValue - Date value to parse (Date object, ISO string, null, or undefined)
 * @returns Date object
 */
export const parseDate = (
  dateValue: Date | string | null | undefined,
): Date => {
  if (!dateValue) {
    return now();
  }

  // If it's already a Date object, return it
  if (dateValue instanceof Date) {
    return isValid(dateValue) ? dateValue : new Date(dateValue);
  }

  // If it's a string, try to parse it
  if (typeof dateValue === "string") {
    try {
      const parsedDate = parseISO(dateValue);
      return isValid(parsedDate) ? parsedDate : now();
    } catch {
      return new Date(dateValue);
    }
  }

  return now();
};
